// extracted by mini-css-extract-plugin
module.exports = {"drawer":"styles_drawer__30Bz5","items":"styles_items__3lUHq","totals":"styles_totals__FyEEJ","plusIcon":"styles_plusIcon__2nKBQ","flexBetween":"styles_flexBetween__1yDyQ"};